<template>
    <el-container>
      <main>
        <h1>Summary</h1>
        <p>Thank you for your order, you will receive confirmation via email or text shortly. Your order reference is <strong>{{order.booking_id}}</strong>.</p>
      </main>
      <aside>
        <cart :editable="false" />
      </aside>
    </el-container>
</template>

<script>
  import { mapState } from 'vuex'
  import cart from '../components/cart'

  export default {
    components: {
      cart
    },
    mounted() {
      //this.$store.commit('order/resetOrder')
    },
    computed: {
      ...mapState({
        order: state => state.order.order
      })
    }
  }
</script>
